import React from "react";
const imgStyle = {
  width: "100%",
  height: "100%",
};
export const titleImg = () => {
  return (
    <>
      <svg
        style={imgStyle}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 1126.151 893.308"
      >
        <defs>
          <linearGradient
            id="linear-gradient"
            x1="0.5"
            y1="1"
            x2="0.5"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stop-color="gray" stop-opacity="0.251" />
            <stop offset="0.54" stop-color="gray" stop-opacity="0.122" />
            <stop offset="1" stop-color="gray" stop-opacity="0.102" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-2"
            x1="0.5"
            y1="1"
            x2="0.5"
            y2="0"
            xlinkHref="#linear-gradient"
          />
        </defs>
        <g
          id="Group_1"
          data-name="Group 1"
          transform="translate(-495.36 -1151)"
        >
          <g id="undraw_gaming_6oy3" transform="translate(495.36 1151)">
            <path
              id="Path_4"
              data-name="Path 4"
              d="M1138.218,514.581c-43.756,68.792-37.8,161.29-20.754,233.973,5.7,24.334,12.325,49.965,6.422,77.477-7.218,33.593-31.477,60.33-55.793,75.808-44.321,28.225-94.245,28.427-129.988.532-30.888-24.111-50.651-66.8-82.231-89.586-52.841-38.111-126.921-12.948-191.638,24.887-45.785,26.768-96.251,60.542-137.644,42.789-29.124-12.491-46.673-49-54.375-88.948-3.724-19.284-5.765-40.4-14.931-54.972-5.454-8.664-13.075-14.383-21-19.04-72.373-42.523-172.326-3.838-241.955-52.176-47.03-32.647-72.707-101.439-80.052-175.408s1.672-153.434,12.521-231.751c7.713-55.631,17.825-115.237,48.126-160.96,32.053-48.37,81.447-70.652,123.877-66.974S377.6,60,408.746,92.083c38.913,40.121,73.688,91.637,124.892,103.831,34.878,8.3,73.4-2.838,110.779-9.451,62.48-11.056,123.819-9.419,184.709-6.91,58.3,2.4,116.924,5.677,170.873,25.035,38.175,13.7,67.069,43.2,102.616,62.062,23.14,12.289,49.521,13.395,70.966,29.968,26.427,20.422,48.852,58.629,37.057,107.69C1199.419,450.988,1161.486,478.065,1138.218,514.581Z"
              transform="translate(-111.616 -29.842)"
              fill="#6c63ff"
              opacity="0.1"
            />
            <g id="stem">
              <path
                id="Path_5"
                data-name="Path 5"
                d="M288.988,714.031s-76.927-117.481-55.343-222.9c9.074-44.245,3.24-90.021-18.286-130.439A346.078,346.078,0,0,0,179.12,306.16"
                transform="translate(-101.289 -12.413)"
                fill="none"
                stroke="#535461"
                stroke-miterlimit="10"
                stroke-width="2"
              />
            </g>
            <path
              id="Path_6"
              data-name="Path 6"
              d="M198.873,244.906c4.439,15.606-13.317,68.271-13.317,68.271s-43.525-37.835-47.976-53.441,5.65-31.588,22.575-35.7,34.26,5.209,38.717,20.815Z"
              transform="translate(-107.805 -17.654)"
              fill="#6c63ff"
            />
            <path
              id="Path_7"
              data-name="Path 7"
              d="M264.032,315.666C258.567,331,212.609,366.3,212.609,366.3s-14.239-53.568-8.763-68.9,23.377-23.661,40-18.617,25.661,21.556,20.191,36.882Z"
              transform="translate(-97.698 -14.233)"
              fill="#6c63ff"
            />
            <path
              id="Path_8"
              data-name="Path 8"
              d="M300,455.872C286.89,466.5,227.88,475.645,227.88,475.645s17.041-52.867,30.151-63.551,33.134-9.546,44.721,2.544,10.351,30.552-2.762,41.235Z"
              transform="translate(-93.829 -6.193)"
              fill="#6c63ff"
            />
            <path
              id="Path_9"
              data-name="Path 9"
              d="M301.77,567.06c-10.965,12.576-67.45,30.723-67.45,30.723s7.1-54.77,18.067-67.335,30.909-14.57,44.546-4.46,15.8,28.5,4.837,41.072Z"
              transform="translate(-92.844 1.046)"
              fill="#6c63ff"
            />
            <path
              id="Path_10"
              data-name="Path 10"
              d="M158.452,381.772c15.231,7.931,74.944,5.507,74.944,5.507s-28.594-48.444-43.814-56.343a34.007,34.007,0,0,0-32.15-.213c-9.963,5.32-16.012,15.2-15.8,25.817s6.651,20.286,16.819,25.264Z"
              transform="translate(-107.024 -11.112)"
              fill="#6c63ff"
            />
            <path
              id="Path_11"
              data-name="Path 11"
              d="M163.988,512.19c17.11,3.37,73.353-15.436,73.353-15.436s-42.983-38.335-60.128-41.715c-17.113-3.367-33.947,6.695-37.6,22.474s7.261,31.3,24.374,34.667Z"
              transform="translate(-107.44 -3.063)"
              fill="#6c63ff"
            />
            <path
              id="Path_12"
              data-name="Path 12"
              d="M184.855,638.082c16.246,5.985,75.129-3.785,75.129-3.785s-35.362-44.49-51.608-50.475c-16.055-5.314-33.792,2.046-40.125,16.651s1.012,31.21,16.615,37.566Z"
              transform="translate(-103.299 4.992)"
              fill="#6c63ff"
            />
            <g id="topLeaf">
              <path
                id="path10"
                d="M198.873,244.906c4.439,15.606-13.317,68.271-13.317,68.271s-43.525-37.835-47.976-53.441,5.65-31.588,22.575-35.7,34.26,5.209,38.717,20.815Z"
                transform="translate(-107.805 -17.654)"
                fill="#6c63ff"
              />
            </g>
            <g id="topRightLeaf">
              <path
                id="path_13"
                data-name="path 13"
                d="M264.032,315.666C258.567,331,212.609,366.3,212.609,366.3s-14.239-53.568-8.763-68.9,23.377-23.661,40-18.617,25.661,21.556,20.191,36.882Z"
                transform="translate(-97.698 -14.233)"
                fill="#6c63ff"
              />
            </g>
            <path
              id="Path_15"
              data-name="Path 15"
              d="M300,455.872C286.89,466.5,227.88,475.645,227.88,475.645s17.041-52.867,30.151-63.551,33.134-9.546,44.721,2.544,10.351,30.552-2.762,41.235Z"
              transform="translate(-93.829 -6.193)"
              fill="#fc6681"
            />
            <path
              id="Path_16"
              data-name="Path 16"
              d="M301.77,567.06c-10.965,12.576-67.45,30.723-67.45,30.723s7.1-54.77,18.067-67.335,30.909-14.57,44.546-4.46,15.8,28.5,4.837,41.072Z"
              transform="translate(-92.844 1.046)"
              fill="#fc6681"
            />
            <g id="topLeftLeaf">
              <path
                id="path_17"
                data-name="path 17"
                d="M158.452,381.772c15.231,7.931,74.944,5.507,74.944,5.507s-28.594-48.444-43.814-56.343a34.007,34.007,0,0,0-32.15-.213c-9.963,5.32-16.012,15.2-15.8,25.817s6.651,20.286,16.819,25.264Z"
                transform="translate(-107.024 -11.112)"
                fill="#6c63ff"
              />
            </g>
            <path
              id="Path_18"
              data-name="Path 18"
              d="M163.988,512.19c17.11,3.37,73.353-15.436,73.353-15.436s-42.983-38.335-60.128-41.715c-17.113-3.367-33.947,6.695-37.6,22.474s7.261,31.3,24.374,34.667Z"
              transform="translate(-107.44 -3.063)"
              fill="#6c63ff"
            />
            <path
              id="Path_19"
              data-name="Path 19"
              d="M184.855,638.082c16.246,5.985,75.129-3.785,75.129-3.785s-35.362-44.49-51.608-50.475c-16.055-5.314-33.792,2.046-40.125,16.651s1.012,31.21,16.615,37.566Z"
              transform="translate(-103.299 4.992)"
              fill="#6c63ff"
            />
            <ellipse
              id="Ellipse_1"
              data-name="Ellipse 1"
              cx="554.011"
              cy="35.082"
              rx="554.011"
              ry="35.082"
              transform="translate(18.13 679.931)"
              fill="#6c63ff"
              opacity="0.1"
            />
            <path
              id="Path_20"
              data-name="Path 20"
              d="M1053.6,700.769s-.922-1.137-2.2-2.413l.369-.117s-16.465-37.941-12.8-53.962-14.631-54.8-14.631-54.8-26.991-50.964-14.216-91.637a101.827,101.827,0,0,0,3.3-14.6c3.816-24.089,2.467-29.054-3.932-37.856l-.7-.946a7.442,7.442,0,0,0,1.833-2.5c5.488-13.49-25.6-37.941-17.329-60.712,7.633-21.1-12.233-64.646-15.185-70.907h0l-.334-.712-.992.3a21.377,21.377,0,0,1,6.526-14.6l.184-.17c2.744-2.328,6.076-4.04,8.647-6.538l.15-.159c.254-.223.519-.447.761-.68,2.548-2.466,4.289-6.123,2.906-9.291-1.257-2.892-4.785-4.656-5.615-7.675a36.466,36.466,0,0,1-.369-4.093c-.669-4.252-5.154-6.921-9.224-9.026-5.062-2.636-10.377-5.315-16.223-5.379-7.91,0-14.989,4.89-22.841,5.5-2.675.213-5.454-.085-7.99.734a18.033,18.033,0,0,0-5.246,3.1,25.191,25.191,0,0,0-2.56,2.126c-1.776,1.531-3.286,3.338-3.217,5.507a5.846,5.846,0,0,0,2.237,4.093,25.318,25.318,0,0,0-4.857,22.359,27.52,27.52,0,0,0,15.453,17.8c.092.585.185,1.18.277,1.807,1.153,7.984,1.833,19.274-1.245,28.118-13.133,6.24-33.6,16.414-37.265,20.932a2.985,2.985,0,0,0-.484,2.647,3.328,3.328,0,0,0-.069,1.265c-2.871.606-6.687,0-11.334-3.912-10.977-9.27-45.716-37.1-45.716-37.1s-15.542-35.411-26.519-28.7,12.8,39.632,12.8,39.632l52.046,51.453s1.833,10.96,21.031,5.06c6.341-1.945,12.072-3.806,16.914-5.411l1.153.9c-4.324,23.324-6.561,54.408,9.385,63.529a13.78,13.78,0,0,1,2.652,5.124c-.081.276-.161.563-.231.84a75.1,75.1,0,0,0-2.306,14.181,42.032,42.032,0,0,0-4.047,20.135L916.429,574.3s-.911,17.7,5.488,31.191,26.519,80.943,12.8,86l1.3.159c-3.932,3.731-10.55,9.387-15.588,10.5-7.656,1.68-5.511,12.5,11.461,14.309s19.013,1.658,30.946-7.516c10.515-8.079,12.187-11.694,12.429-12.47l.6.074s-6.4-21.921,0-31.191-14.62-65.751-14.62-65.751a168.14,168.14,0,0,1,.865-21.623c3.228,7.792,5.534,13.193,5.534,13.193s5.488,24.451,11.887,28.7,40.239,62.392,34.751,87.682l-.634,2.945,1.545-.415h.138c-2.11,4.816-5.949,12.427-10.193,15.223-6.4,4.252,0,13.49,16.465,9.27s18.286-5.06,25.608-17.7S1053.6,700.769,1053.6,700.769Z"
              transform="translate(-4.733 -15.81)"
              fill="url(#linear-gradient)"
            />
            <path
              id="Path_21"
              data-name="Path 21"
              d="M918.292,462.671l-4.012-4.561a41.3,41.3,0,0,0-5.661,22.931l-5.972,78.487s-.9,17.307,5.361,30.5,25.931,79.135,12.521,84.079l40.182,5.007s-6.261-21.432,0-30.5S946.4,584.318,946.4,584.318s-1.787-46.159,15.2-56.885S918.292,462.671,918.292,462.671Z"
              transform="translate(9.396 -2.829)"
              fill="#555388"
            />
            <path
              id="Path_22"
              data-name="Path 22"
              d="M925.092,658.4s-11.034,11.885-18.505,13.533-5.384,12.215,11.207,13.99,18.586,1.627,30.266-7.346,12.2-12.342,12.2-12.342-2.306-7.973-5.1-8.143S925.092,658.4,925.092,658.4Z"
              transform="translate(9.375 9.783)"
              fill="#603556"
            />
            <path
              id="Path_23"
              data-name="Path 23"
              d="M920.977,465.148l-6.687-7.038a41.3,41.3,0,0,0-5.661,22.931l-5.972,78.487s-.9,17.307,5.361,30.5,25.931,79.135,12.521,84.079l40.17,5.007s-6.261-21.432,0-30.5S946.4,584.318,946.4,584.318s-1.787-46.159,15.2-56.885S920.977,465.148,920.977,465.148Z"
              transform="translate(9.397 -2.829)"
              opacity="0.1"
            />
            <path
              id="Path_24"
              data-name="Path 24"
              d="M1066.344,587.664s-11.172-202.208-57.038-273.774c0,0-33.633-56.641-61.743-73.161V234.2c-45.866-29.277-102.3,0-102.3,0v2.892L833.5,246.13l-52.957-.17a26.426,26.426,0,0,0-19.659-8.5H519.24a26.542,26.542,0,0,0-18.794,7.59h-55s-3.24-3.476-11.76-6.974V234.2c-45.866-29.277-102.3,0-102.3,0v7.856a14.722,14.722,0,0,0-3.528,2.987s-46.454,28.7-57.038,64.507c0,0-57.038,157.761-58.214,281.364s50.57,140.953,77.608,144.206,75.256-1.063,122.3-110.56L432.5,560.6s3.528-37.952,45.866-14.1,79.96-13.012,79.96-13.012H717.093s52.865,30.319,101.129,6.421c0,0,18.817-22.771,36.458,54.217,0,0,54.1,158.3,137.586,142.038S1066.344,587.664,1066.344,587.664Z"
              transform="translate(-96.169 -17.773)"
              fill="url(#linear-gradient-2)"
            />
            <path
              id="Path_25"
              data-name="Path 25"
              d="M320.84,250.381V238.687s55.343-28.7,100.31,0v10.631Z"
              transform="translate(-79.607 -17.474)"
              fill="#535461"
            />
            <path
              id="Path_26"
              data-name="Path 26"
              d="M757.84,250.381V238.687s55.343-28.7,100.31,0v10.631Z"
              transform="translate(-12.751 -17.474)"
              fill="#535461"
            />
            <path
              id="Path_27"
              data-name="Path 27"
              d="M320.84,250.381V238.687s55.343-28.7,100.31,0v10.631Z"
              transform="translate(-79.607 -17.474)"
              opacity="0.1"
            />
            <path
              id="Path_28"
              data-name="Path 28"
              d="M757.84,250.381V238.687s55.343-28.7,100.31,0v10.631Z"
              transform="translate(-12.751 -17.474)"
              opacity="0.1"
            />
            <path
              id="Path_29"
              data-name="Path 29"
              d="M502.325,248.753h-54.19s-13.836-14.883-59.955-13.82-55.343,13.82-55.343,13.82-45.543,28.172-55.92,63.253c0,0-55.92,154.678-57.073,275.868s49.579,138.2,76.1,141.389S369.731,728.2,415.851,620.83l19.6-62.721s3.459-37.208,44.967-13.82,78.4-12.757,78.4-12.757H714.474s51.885,29.766,99.157,6.378c0,0,18.448-22.325,35.743,53.154,0,0,53.037,155.209,134.9,139.263s72.638-145.641,72.638-145.641-10.953-198.264-55.92-268.427c0,0-43.237-72.821-72.062-76.01,0,0-62.261-10.631-86.474-1.063L828.62,249.816Z"
              transform="translate(-95.061 -16.909)"
              fill="#535461"
            />
            <ellipse
              id="Ellipse_2"
              data-name="Ellipse 2"
              cx="100.31"
              cy="92.488"
              rx="100.31"
              ry="92.488"
              transform="translate(181.277 243.538)"
              fill="#e2e2ec"
            />
            <ellipse
              id="Ellipse_3"
              data-name="Ellipse 3"
              cx="100.31"
              cy="92.488"
              rx="100.31"
              ry="92.488"
              transform="translate(704.734 243.538)"
              fill="#e2e2ec"
            />
            <path
              id="Path_30"
              data-name="Path 30"
              d="M375.919,328.9l-13.375,10.907a6.6,6.6,0,0,1-8.2,0l-13.4-10.907a5.529,5.529,0,0,1-2.1-4.252V294.639a5.977,5.977,0,0,1,6.2-5.709H371.86a6.468,6.468,0,0,1,4.39,1.672,5.492,5.492,0,0,1,1.813,4.047v29.979a5.536,5.536,0,0,1-2.145,4.274Z"
              transform="translate(-76.852 -13.5)"
              fill="#535461"
            />
            <path
              id="Path_31"
              data-name="Path 31"
              d="M375.919,366.051l-13.375-10.9a6.6,6.6,0,0,0-8.2,0l-13.4,10.907a5.529,5.529,0,0,0-2.1,4.252v29.979a5.492,5.492,0,0,0,1.813,4.047,6.468,6.468,0,0,0,4.39,1.672H371.86a6.469,6.469,0,0,0,4.386-1.668,5.493,5.493,0,0,0,1.818-4.04V370.325a5.536,5.536,0,0,0-2.145-4.274Z"
              transform="translate(-76.852 -9.413)"
              fill="#535461"
            />
            <path
              id="Path_32"
              data-name="Path 32"
              d="M342.2,363.139l11.83-12.353a5.389,5.389,0,0,0,0-7.558L342.2,330.875a6.439,6.439,0,0,0-4.612-1.935H305.072a5.975,5.975,0,0,0-6.192,5.719v24.717a5.492,5.492,0,0,0,1.813,4.047,6.468,6.468,0,0,0,4.39,1.672H337.6a6.422,6.422,0,0,0,4.6-1.956Z"
              transform="translate(-82.967 -10.976)"
              fill="#535461"
            />
            <path
              id="Path_33"
              data-name="Path 33"
              d="M377.012,363.14l-11.807-12.364a5.38,5.38,0,0,1,0-7.558l11.83-12.353a6.428,6.428,0,0,1,4.612-1.935h32.514a6.468,6.468,0,0,1,4.39,1.672,5.492,5.492,0,0,1,1.813,4.047v24.717a5.491,5.491,0,0,1-1.809,4.044,6.467,6.467,0,0,1-4.382,1.676H381.659a6.428,6.428,0,0,1-4.647-1.945Z"
              transform="translate(-73.057 -10.977)"
              fill="#535461"
            />
            <path
              id="Path_34"
              data-name="Path 34"
              d="M229.18,252.9h34.59l-17.295-13.82Z"
              transform="translate(35.113 15.088)"
              fill="none"
              stroke="#535461"
              stroke-miterlimit="10"
              stroke-width="2"
            />
            <path
              id="Path_35"
              data-name="Path 35"
              d="M229.18,380.08h34.59L246.475,393.9Z"
              transform="translate(35.113 23.982)"
              fill="none"
              stroke="#535461"
              stroke-miterlimit="10"
              stroke-width="2"
            />
            <path
              id="Path_36"
              data-name="Path 36"
              d="M182.169,301.08v31.892L167.18,317.026Z"
              transform="translate(25.627 18.999)"
              fill="none"
              stroke="#535461"
              stroke-miterlimit="10"
              stroke-width="2"
            />
            <path
              id="Path_37"
              data-name="Path 37"
              d="M308.18,301.08v31.892l14.989-15.946Z"
              transform="translate(47.199 18.999)"
              fill="none"
              stroke="#535461"
              stroke-miterlimit="10"
              stroke-width="2"
            />
            <ellipse
              id="Ellipse_4"
              data-name="Ellipse 4"
              cx="72.638"
              cy="66.974"
              rx="72.638"
              ry="66.974"
              transform="translate(345.002 370.044)"
              fill="#e2e2ec"
            />
            <ellipse
              id="Ellipse_5"
              data-name="Ellipse 5"
              cx="48.426"
              cy="44.649"
              rx="48.426"
              ry="44.649"
              transform="translate(366.909 381.738)"
              fill="#535461"
            />
            <ellipse
              id="Ellipse_6"
              data-name="Ellipse 6"
              cx="72.638"
              cy="66.974"
              rx="72.638"
              ry="66.974"
              transform="translate(596.353 370.044)"
              fill="#e2e2ec"
            />
            <ellipse
              id="Ellipse_7"
              data-name="Ellipse 7"
              cx="48.426"
              cy="44.649"
              rx="48.426"
              ry="44.649"
              transform="translate(618.26 381.738)"
              fill="#535461"
            />
            <ellipse
              id="Ellipse_8"
              data-name="Ellipse 8"
              cx="32.284"
              cy="29.766"
              rx="32.284"
              ry="29.766"
              transform="translate(383.05 396.621)"
              fill="none"
              stroke="#000"
              stroke-miterlimit="10"
              stroke-width="2"
              opacity="0.1"
            />
            <ellipse
              id="Ellipse_9"
              data-name="Ellipse 9"
              cx="32.284"
              cy="29.766"
              rx="32.284"
              ry="29.766"
              transform="translate(634.402 396.621)"
              fill="none"
              stroke="#000"
              stroke-miterlimit="10"
              stroke-width="2"
              opacity="0.1"
            />
            <ellipse
              id="Ellipse_10"
              data-name="Ellipse 10"
              cx="20.754"
              cy="19.135"
              rx="20.754"
              ry="19.135"
              transform="translate(524.868 425.324)"
              fill="#e2e2ec"
            />
            <ellipse
              id="Ellipse_11"
              data-name="Ellipse 11"
              cx="4.531"
              cy="4.178"
              rx="4.531"
              ry="4.178"
              transform="translate(509.372 376.412)"
              fill="#e2e2ec"
            />
            <ellipse
              id="Ellipse_12"
              data-name="Ellipse 12"
              cx="4.531"
              cy="4.178"
              rx="4.531"
              ry="4.178"
              transform="translate(526.344 376.412)"
              fill="#e2e2ec"
            />
            <ellipse
              id="Ellipse_13"
              data-name="Ellipse 13"
              cx="4.531"
              cy="4.178"
              rx="4.531"
              ry="4.178"
              transform="translate(524.084 396.238)"
              fill="#e2e2ec"
            />
            <ellipse
              id="Ellipse_14"
              data-name="Ellipse 14"
              cx="4.612"
              cy="4.252"
              rx="4.612"
              ry="4.252"
              transform="translate(539.857 396.621)"
              fill="#e2e2ec"
            />
            <ellipse
              id="Ellipse_15"
              data-name="Ellipse 15"
              cx="4.531"
              cy="4.178"
              rx="4.531"
              ry="4.178"
              transform="translate(555.768 396.238)"
              fill="#e2e2ec"
            />
            <ellipse
              id="Ellipse_16"
              data-name="Ellipse 16"
              cx="4.531"
              cy="4.178"
              rx="4.531"
              ry="4.178"
              transform="translate(517.293 386.851)"
              fill="#e2e2ec"
            />
            <ellipse
              id="Ellipse_17"
              data-name="Ellipse 17"
              cx="4.612"
              cy="4.252"
              rx="4.612"
              ry="4.252"
              transform="translate(531.786 387.053)"
              fill="#e2e2ec"
            />
            <ellipse
              id="Ellipse_18"
              data-name="Ellipse 18"
              cx="4.612"
              cy="4.252"
              rx="4.612"
              ry="4.252"
              transform="translate(546.775 387.053)"
              fill="#e2e2ec"
            />
            <ellipse
              id="Ellipse_19"
              data-name="Ellipse 19"
              cx="4.531"
              cy="4.178"
              rx="4.531"
              ry="4.178"
              transform="translate(562.559 386.851)"
              fill="#e2e2ec"
            />
            <ellipse
              id="Ellipse_20"
              data-name="Ellipse 20"
              cx="4.612"
              cy="4.252"
              rx="4.612"
              ry="4.252"
              transform="translate(539.857 376.422)"
              fill="#e2e2ec"
            />
            <ellipse
              id="Ellipse_21"
              data-name="Ellipse 21"
              cx="4.612"
              cy="4.252"
              rx="4.612"
              ry="4.252"
              transform="translate(555.999 376.422)"
              fill="#e2e2ec"
            />
            <ellipse
              id="Ellipse_22"
              data-name="Ellipse 22"
              cx="4.531"
              cy="4.178"
              rx="4.531"
              ry="4.178"
              transform="translate(569.35 376.412)"
              fill="#e2e2ec"
            />
            <rect
              id="Rectangle_5"
              data-name="Rectangle 5"
              width="25.366"
              height="40.397"
              rx="8.5"
              transform="translate(363.45 239.285)"
              fill="#e2e2ec"
            />
            <rect
              id="Rectangle_6"
              data-name="Rectangle 6"
              width="25.366"
              height="40.397"
              rx="8.5"
              transform="translate(700.122 239.285)"
              fill="#e2e2ec"
            />
            <ellipse
              id="Ellipse_23"
              data-name="Ellipse 23"
              cx="27.672"
              cy="25.514"
              rx="27.672"
              ry="25.514"
              transform="translate(778.525 254.168)"
              fill="#535461"
            />
            <ellipse
              id="Ellipse_24"
              data-name="Ellipse 24"
              cx="27.672"
              cy="25.514"
              rx="27.672"
              ry="25.514"
              transform="translate(719.723 308.385)"
              fill="#535461"
            />
            <ellipse
              id="Ellipse_25"
              data-name="Ellipse 25"
              cx="27.672"
              cy="25.514"
              rx="27.672"
              ry="25.514"
              transform="translate(839.634 305.196)"
              fill="#535461"
            />
            <ellipse
              id="Ellipse_26"
              data-name="Ellipse 26"
              cx="27.672"
              cy="25.514"
              rx="27.672"
              ry="25.514"
              transform="translate(783.137 361.539)"
              fill="#535461"
            />
            <rect
              id="Rectangle_7"
              data-name="Rectangle 7"
              width="287.094"
              height="141.389"
              rx="21.75"
              transform="translate(400.345 224.402)"
              fill="#e2e2ec"
            />
            <path
              id="Path_38"
              data-name="Path 38"
              d="M684.68,274.594l16.142-25.514,17.295,25.514Z"
              transform="translate(104.799 15.719)"
              fill="none"
              stroke="#e2e2ec"
              stroke-miterlimit="10"
              stroke-width="2"
            />
            <rect
              id="Rectangle_8"
              data-name="Rectangle 8"
              width="28.825"
              height="23.388"
              transform="translate(732.982 322.205)"
              fill="none"
              stroke="#e2e2ec"
              stroke-miterlimit="10"
              stroke-width="2"
            />
            <ellipse
              id="Ellipse_27"
              data-name="Ellipse 27"
              cx="16.142"
              cy="14.883"
              rx="16.142"
              ry="14.883"
              transform="translate(851.164 315.827)"
              fill="none"
              stroke="#e2e2ec"
              stroke-miterlimit="10"
              stroke-width="2"
            />
            <line
              id="Line_1"
              data-name="Line 1"
              x2="25.942"
              y2="23.919"
              transform="translate(797.55 375.093)"
              fill="none"
              stroke="#e2e2ec"
              stroke-miterlimit="10"
              stroke-width="2"
            />
            <line
              id="Line_2"
              data-name="Line 2"
              x1="26.519"
              y2="23.388"
              transform="translate(797.55 375.093)"
              fill="none"
              stroke="#e2e2ec"
              stroke-miterlimit="10"
              stroke-width="2"
            />
            <g id="bottomLeaf">
              <path
                id="path_41"
                data-name="path 41"
                d="M465.621,696.149c3.459-2.434,6.745-5.315,7.748-8.792a7.376,7.376,0,0,0-5.407-8.951c-4.969-1.425-10.273,1.159-14.309,3.774s-8.636,5.6-13.905,5.05c5.454-3.636,8.071-9.568,6.549-14.883a5.667,5.667,0,0,0-1.822-3.03c-2.756-2.222-7.76-1.265-11.057.478-10.5,5.56-13.432,16.286-13.49,25.95-1.061-3.487-.161-7.112-.2-10.695s-1.326-7.537-5.338-9.461a20.5,20.5,0,0,0-8.14-1.435c-4.716-.128-9.985.223-13.2,2.828-4,3.189-2.963,8.643.519,12.193s8.786,5.783,13.663,8.239c3.724,1.871,7.483,4.05,9.766,7.006a6.234,6.234,0,0,1,.726,1.254h29.6a87.283,87.283,0,0,0,18.3-9.525Z"
                transform="translate(-68.954 10.412)"
                fill="#6c63ff"
              />
            </g>
            <path
              id="Path_40"
              data-name="Path 40"
              d="M989.8,675.129s-5.361,14.883-11.622,18.965,0,13.193,16.142,9.068,17.883-4.943,25.031-17.307,6.261-15.659,6.261-15.659-5.362-6.591-8.071-5.772S989.8,675.129,989.8,675.129Z"
              transform="translate(20.592 10.18)"
              fill="#603556"
            />
            <path
              id="Path_41-2"
              data-name="Path 41"
              d="M966.948,328.263s-72.419,37.091-55.436,26.375c11.415-7.2,10.723-26.3,9.039-38.069-.53-3.668-1.153-6.623-1.533-8.281-.219-.935-.357-1.456-.357-1.456s35.12-19.433,33.148-7.75h0a.626.626,0,0,1-.058.319,11.654,11.654,0,0,0-.265,2.371C951.244,313.784,966.948,328.263,966.948,328.263Z"
              transform="translate(10.364 -13.095)"
              fill="#c87486"
            />
            <path
              id="Path_42"
              data-name="Path 42"
              d="M903,364.294s-6.261,9.068-16.984,0-44.7-36.272-44.7-36.272S826.122,293.4,815.376,300,827.9,338.749,827.9,338.749l50.962,50.284s1.787,10.716,20.569,4.943S931.62,383.26,931.62,383.26Z"
              transform="translate(-4.383 -12.855)"
              fill="#c87486"
            />
            <path
              id="Path_43"
              data-name="Path 43"
              d="M915.83,439.53"
              transform="translate(11.419 -4.001)"
              fill="none"
            />
            <path
              id="Path_44"
              data-name="Path 44"
              d="M1033.044,682.428,997.3,693.973l-1.51.4.623-2.881c5.361-24.727-27.672-81.612-33.979-85.737S950.79,577.7,950.79,577.7s-11.714-54.408-13.5-65.911c-.45-2.881-2.087-5.177-4.07-8.345a63.325,63.325,0,0,1-6.918-15.266c-3.932-12.757-13.1-35.4-9.731-48.211.68-2.6-2.1,4.05-1.153,1.51l.542-1.4L988.343,431a50.3,50.3,0,0,1,3.367,4.2c5.477,7.495,5.119,7.495,6.272,21.74a136.291,136.291,0,0,1-3.932,25.514c-9.743,40,12.233,93.551,12.233,93.551s17.883,37.92,14.308,53.579S1033.044,682.428,1033.044,682.428Z"
              transform="translate(11.326 -4.539)"
              fill="#555388"
            />
            <path
              id="Path_45"
              data-name="Path 45"
              d="M992.015,435.189c-10.711,12.385-79.326,22.006-78.472,18.072a7.736,7.736,0,0,0-.323-4.061,75.742,75.742,0,0,1,2.467-7.728l.542-1.4L988.648,431a50.333,50.333,0,0,1,3.367,4.189Z"
              transform="translate(11.02 -4.539)"
              opacity="0.1"
            />
            <path
              id="Path_46"
              data-name="Path 46"
              d="M961.4,310s-29.516,8.271-37.587,27.236,6.122,20,6.122,20S904.568,418.891,911.29,451c0,0,3.574,4.125,2.687,8.239s74.206-6.591,79.556-19.784S968.5,402.36,976.55,380.1,961.4,310,961.4,310Z"
              transform="translate(10.551 -12.171)"
              fill="#dfe5ee"
            />
            <path
              id="Path_47"
              data-name="Path 47"
              d="M950.415,300.961a2.467,2.467,0,0,1-.265.712c-1.222,2.126-5.108-.2-3.759,2.987-5.188,4.805-6.826,14.426-14.747,14.426a30.443,30.443,0,0,1-12.441-2.6c-.53-3.668-1.153-6.623-1.534-8.281,3.459-1.892,31.131-16.669,32.791-9.206h0A4.527,4.527,0,0,1,950.415,300.961Z"
              transform="translate(11.701 -12.997)"
              opacity="0.1"
            />
            <ellipse
              id="Ellipse_28"
              data-name="Ellipse 28"
              cx="28.606"
              cy="26.375"
              rx="28.606"
              ry="26.375"
              transform="translate(914.728 251.702)"
              fill="#c87486"
            />
            <path
              id="Path_48"
              data-name="Path 48"
              d="M965.116,372.561l-50.063,21.432s-33.979-23.9-28.617-30.478S933.824,338,933.824,338,976.738,346.186,965.116,372.561Z"
              transform="translate(6.835 -10.405)"
              opacity="0.1"
            />
            <path
              id="Path_49"
              data-name="Path 49"
              d="M965.115,371.052l-50.063,21.432s-33.979-23.909-28.606-30.5,47.388-25.514,47.388-25.514S976.737,344.634,965.115,371.052Z"
              transform="translate(6.836 -10.501)"
              fill="#dfe5ee"
            />
            <path
              id="Path_50"
              data-name="Path 50"
              d="M924.872,282.222c-4.37-.4-8.89-.85-12.683-2.881-2.2-1.169-4.22-3.1-4.289-5.454-.081-2.764,2.444-4.922,4.762-6.676a17.627,17.627,0,0,1,5.131-3.03c2.479-.8,5.188-.51,7.806-.712,7.7-.6,14.6-5.422,22.333-5.379,5.684,0,10.907,2.679,15.854,5.262,3.955,2.062,8.348,4.678,9,8.824a35.711,35.711,0,0,0,.357,4c.819,2.955,4.266,4.678,5.5,7.505,1.349,3.094-.357,6.676-2.848,9.089s-5.765,4.072-8.382,6.325A20.891,20.891,0,0,0,959.9,315.4a1.979,1.979,0,0,1-.2,1.18,2.308,2.308,0,0,1-1.614.744c-2.848.489-6.364.755-8.071-1.414s-.357-5.783-2.306-7.92c-2.479-2.753-7.69-.563-11.046-2.371a6.339,6.339,0,0,1-2.537-2.8c-2.767-5.5.4-9.812,1.557-15.064C937.036,281.627,929.565,282.658,924.872,282.222Z"
              transform="translate(10.206 -15.445)"
              opacity="0.1"
            />
            <path
              id="Path_51"
              data-name="Path 51"
              d="M925.652,281.432c-4.37-.4-8.89-.85-12.683-2.881-2.2-1.169-4.22-3.1-4.289-5.454-.081-2.764,2.444-4.922,4.762-6.676a17.628,17.628,0,0,1,5.131-3.03c2.479-.8,5.188-.51,7.806-.712,7.7-.6,14.6-5.422,22.333-5.379,5.684,0,10.907,2.679,15.854,5.262,3.955,2.062,8.348,4.678,9,8.824a35.684,35.684,0,0,0,.358,4c.818,2.955,4.266,4.677,5.5,7.505,1.349,3.094-.357,6.676-2.848,9.089s-5.765,4.072-8.382,6.325a20.891,20.891,0,0,0-7.529,16.35,1.977,1.977,0,0,1-.2,1.18,2.308,2.308,0,0,1-1.614.744c-2.848.489-6.364.755-8.071-1.414s-.357-5.783-2.306-7.92c-2.479-2.753-7.69-.563-11.046-2.371a6.339,6.339,0,0,1-2.537-2.8c-2.79-5.507.392-9.855,1.545-15.159C937.8,280.847,930.333,281.889,925.652,281.432Z"
              transform="translate(10.325 -15.495)"
              fill="#603456"
            />
          </g>
        </g>
      </svg>
    </>
  );
};
